"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require("babel-runtime/regenerator");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _asyncToGenerator2 = require("babel-runtime/helpers/asyncToGenerator");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require("react-redux");

var _reactRouterRedux = require("react-router-redux");

var _url = require("url");

var _url2 = _interopRequireDefault(_url);

var _reactIntl = require("react-intl");

var _reactBootstrap = require("react-bootstrap");

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _auth = require("../../redux/modules/auth");

var _popup = require("../../redux/modules/popup");

var _BaseButton = require("../../components/BaseButton/BaseButton");

var _BaseButton2 = _interopRequireDefault(_BaseButton);

var _Product = require("../../helpers/Product");

var _Router = require("../../helpers/Router");

var _DefaultString = require("../../helpers/DefaultString");

var _FormatTvCodeError = require("../../helpers/FormatTvCodeError");

var _Cookie = require("../../helpers/Cookie");

var _ValidateTvCode = require("../../helpers/ValidateTvCode");

var _stingray_logo_horizontal_white = require("../../../res/images/logo/stingray_logo_horizontal_white.svg");

var _stingray_logo_horizontal_white2 = _interopRequireDefault(_stingray_logo_horizontal_white);

var _TV = require("./TV.scss");

var _TV2 = _interopRequireDefault(_TV);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TV = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(TV, _Component);

  function TV(props) {
    var _this2 = this;

    (0, _classCallCheck3.default)(this, TV);

    var _this = (0, _possibleConstructorReturn3.default)(this, (TV.__proto__ || (0, _getPrototypeOf2.default)(TV)).call(this, props));

    _this.handleFormSubmit = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
      var inputtedCode, response, tvCode, tvData, error, clientId, remainingTime, errorResponse;
      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(_this.state.tvCode.length !== _this.tvCodeLength)) {
                _context.next = 3;
                break;
              }

              _this.setState((0, _extends3.default)({}, _this.state, {
                error: "INVALID_CODE",
                loading: false
              }));
              return _context.abrupt("return");

            case 3:
              _context.prev = 3;

              _this.setState((0, _extends3.default)({}, _this.state, { loading: true }));
              inputtedCode = _this.state.tvCode;
              _context.next = 8;
              return (0, _ValidateTvCode.validateTvCode)(inputtedCode);

            case 8:
              response = _context.sent;

              if (!response) {
                _context.next = 22;
                break;
              }

              tvCode = response.tvCode, tvData = response.tvData, error = response.error;

              if (error) {
                _context.next = 19;
                break;
              }

              clientId = tvData.clientId, remainingTime = tvData.remainingTime;


              _this.props.tvFlowStarted(tvCode, clientId);
              sessionStorage.setItem(_Cookie.tvCodeSessionStorageName, tvCode);
              sessionStorage.setItem(_Cookie.tvCodeExpirySessionStorageName, Date.now() + remainingTime);

              // Use window.location to redirect to force product check
              window.location.href = window.location.origin + "/" + _Router.RouterConst.Welcome + "?client_id=" + clientId + "&redirect_uri=tvcode";
              _context.next = 20;
              break;

            case 19:
              throw new Error(error);

            case 20:
              _context.next = 23;
              break;

            case 22:
              throw new Error("NO_RESPONSE");

            case 23:
              _context.next = 28;
              break;

            case 25:
              _context.prev = 25;
              _context.t0 = _context["catch"](3);

              if (_context.t0.response.data.error) {
                errorResponse = _context.t0.response.data.error;

                console.error(errorResponse);
                _this.setState((0, _extends3.default)({}, _this.state, { loading: false, error: errorResponse }));
              } else {
                console.error(_context.t0);
                _this.setState((0, _extends3.default)({}, _this.state, { loading: false, error: _context.t0 }));
              }

            case 28:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this2, [[3, 25]]);
    }));

    _this.handleCodeChange = function (input) {
      if (input.length <= 4) {
        var processedInput = input.toUpperCase().replace(/[^a-z0-9]/gi, "").trim();
        _this.setState((0, _extends3.default)({}, _this.state, { tvCode: processedInput, error: null }));
      }
      return;
    };

    _this.handleEnterKey = function (event) {
      if (event.key === "Enter") {
        event.preventDefault();
        _this.handleFormSubmit();
      }
    };

    _this.state = { tvCode: "", loading: false, error: null };
    _this.isMusic = _this.props.auth.productName === _Product.PRODUCT_NAMES.Music;
    _this.tvCodeLength = 4;
    return _this;
  }

  (0, _createClass3.default)(TV, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this3 = this;

      var query = _url2.default.parse(window.location.href, true).query;
      var tv_code = query.tv_code;
      if (tv_code) {
        this.setState((0, _extends3.default)({}, this.state, {
          tvCode: tv_code.slice(0, this.tvCodeLength)
        }), function () {
          // Auto-submit the form if a valid code is provided via URL parameter
          if (_this3.state.tvCode.length === _this3.tvCodeLength) {
            _this3.handleFormSubmit();
          }
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.setState((0, _extends3.default)({}, this.state, { error: null }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var productClassName = (0, _Product.getProductClassNameWithoutClientId)(this.props.auth.realm, this.props.auth.productName);

      var formatMessage = this.props.intl.formatMessage;


      return _react2.default.createElement(
        "div",
        { className: (0, _classnames2.default)(_TV2.default.tvComponent, productClassName) },
        _react2.default.createElement(
          "div",
          { className: this.isMusic ? _TV2.default.musicContent : _TV2.default.content },
          _react2.default.createElement(
            _reactBootstrap.Form,
            { onSubmit: this.handleFormSubmit },
            _react2.default.createElement(
              _reactBootstrap.FormGroup,
              { role: "form" },
              _react2.default.createElement(
                "div",
                { className: _TV2.default.title },
                _react2.default.createElement(_reactIntl.FormattedMessage, _DefaultString.translations.TVCodeFormTitle)
              ),
              _react2.default.createElement(
                "div",
                { className: _TV2.default.subtitle },
                _react2.default.createElement(_reactIntl.FormattedMessage, (0, _extends3.default)({}, _DefaultString.translations.TVCodeFormSubtitle, {
                  values: {
                    product: formatMessage((0, _Product.getProductNameWithoutClientId)(this.props.auth.realm, this.props.auth.productName))
                  }
                }))
              ),
              this.state.error && _react2.default.createElement(
                "div",
                { className: _TV2.default.errorMessage },
                (0, _FormatTvCodeError.formatTvCodeError)(this.state.error)
              ),
              _react2.default.createElement(_reactBootstrap.FormControl, {
                className: _TV2.default.textInput,
                name: "code",
                type: "text",
                value: this.state.tvCode,
                onChange: function onChange(e) {
                  return _this4.handleCodeChange(e.target.value);
                },
                onKeyPress: this.handleEnterKey
              }),
              _react2.default.createElement(_BaseButton2.default, {
                className: _TV2.default.submit,
                onClick: this.handleFormSubmit,
                buttonString: _DefaultString.translations.TVCodeFormSubmitButton,
                loading: this.state.loading,
                theme: this.isMusic ? _BaseButton.ButtonTheme.CallToAction : "",
                isInactive: this.state.tvCode.length !== this.tvCodeLength
              })
            )
          )
        ),
        this.isMusic && _react2.default.createElement(
          "div",
          { className: _TV2.default.logo },
          _react2.default.createElement("img", { src: _stingray_logo_horizontal_white2.default })
        )
      );
    }
  }]);
  return TV;
}(_react.Component), _class.propTypes = {
  auth: _react.PropTypes.object,
  intl: _reactIntl.intlShape.isRequired,
  tvFlowStarted: _react.PropTypes.func,
  pushState: _react.PropTypes.func.isRequired
}, _temp);
exports.default = (0, _reactIntl.injectIntl)((0, _reactRedux.connect)(function (state) {
  return { auth: state.auth };
}, {
  changePopupType: _popup.changePopupType,
  tvFlowStarted: _auth.tvFlowStarted,
  pushState: _reactRouterRedux.push
})(TV));
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./src/containers/TV/TV.js
// module id = 2023
// module chunks = 0